export const formats = {
  TEXT: 'text',
  INT: 'int',
  FLOAT: 'float',
  INT_STATIC: 'intStatic',
  PERCENTAGE: 'percentage',
  PERCENTAGE_SCALE: 'percentageScale',
};
